import {Component, inject} from '@angular/core';
import {AuthCard} from "@components/layout/auth/auth-card/auth-card";
import {AuthService} from '@core/services/auth.service';

@Component({
    selector: 'app-redirect-callback',
    imports: [
        AuthCard
    ],
    templateUrl: './redirect-callback.html',
    styleUrl: './redirect-callback.css'
})
export class RedirectCallback {
    private readonly authService = inject(AuthService);

    constructor() {
        this.authService.handleLoginRedirection();
    }
}
